<template>
<header>
  <nav class="fixed top-0 w-full z-50 bg-slate-100 font-montserrat drop-shadow-sm" ref="navbar">
    <div class="flex justify-between py-2 items-center container mx-auto px-2 2xl:px-32">
      <img src="../assets/img/octoverse.png" alt="" class="w-auto h-16 p-1 cursor-pointer" @click="redirectPage('')">
      <ul class="lg:flex font-base lg:text-xs xl:text-sm
       text-octo-secondary hidden font-montserrat items-center gap-6 font-medium uppercase">
        <li><a @click="redirectPage('')" class="hover:text-octo-primary cursor-pointer">Home</a></li>
        <li class="relative group">
          <a href="#" class="hover:text-octo-primary cursor-pointer flex items-center group" @click="redirectPage('Solutions')">Solutions <i class='bx bxs-chevron-down'></i></a>
          <div class="absolute py-2 opacity-0 text-sm invisible font-montserrat rounded-lg w-max
          group-hover:visible group-hover:opacity-100 top-full left-0 bg-slate-100 transition-all duration-500">
            <ul class="py-4 pt-6 px-6 flex gap-4 flex-col">
              <li class="flex">
              <a class="hover:text-octo-primary cursor-pointer" @click="solutionRedirect('#bg-1')">Gateway</a></li>
              <div class="dropdown dropdown-hover">
                <a tabindex="0" class="font-montserrat text-sm uppercase 
                cursor-pointer hover:text-purple-600 py-3" @click="solutionRedirect('#bg-4')">Recharger <i class='bx bxs-chevron-right'></i></a>
                <ul tabindex="0" class="dropdown-content -mt-8 ml-28 px-2 py-3 flex flex-col gap-4 bg-slate-100 rounded-lg w-36">
                  <li><a class="hover:text-octo-primary cursor-pointer pl-4"  @click="redirectPage('Topup')">Top Up</a></li>
                  <li><a class="hover:text-octo-primary cursor-pointer pl-4" @click="redirectPage('Datapack')">Data Pack</a></li>
                  <li><a class="hover:text-octo-primary cursor-pointer pl-4" @click="redirectPage('E-Giftcard')">E-GiftCard</a></li>
                </ul>
              </div>
              <li><a class="hover:text-octo-primary cursor-pointer py-3" @click="solutionRedirect('#bg-6')">Messenger</a></li>
            </ul>
          </div>
        </li>
        <li class="relative"><a @click="redirectPage('news-and-promotion')" class="hover:text-octo-primary cursor-pointer">News & Promotion</a>
        </li>
        <li class="group relative">
          <a @click="redirectPage('AboutUs')" class="hover:text-octo-primary cursor-pointer flex items-center">About Us<i class='bx bxs-chevron-down'></i></a>
          <div class="absolute opacity-0 invisible py-2 font-montserrat rounded-lg w-max
          group-hover:visible group-hover:opacity-100 top-full left-0 bg-slate-100 transition-all duration-500">
            <ul class="py-4 pt-6 px-6 flex flex-col gap-4">
              <li class="flex"><a class="hover:text-octo-primary cursor-pointer" @click="aboutUsRedirect('#ourstory')">Our Story</a></li>
              <li><a @click="aboutUsRedirect('#vision-mission')" class="hover:text-octo-primary cursor-pointer">Vision And Mission</a></li>
              <li><a @click="aboutUsRedirect('#whatwedo')" class="hover:text-octo-primary cursor-pointer">What We Do</a></li>
            </ul>
          </div>
        </li>
        <li><a @click="redirectPage('help-faq')"  class="hover:text-octo-primary cursor-pointer">Help & FAQ</a></li>
      </ul>
      <!-- Mobile -->
      <div class="block md:hidden text-octo-secondary">
        <div class="mr-4">
          <label tabindex="0" class="cursor-pointer" @click="isShow = !isShow">
            <div class="w-6 h-1 bg-gray-600 mb-1"></div>
            <div class="w-6 h-1 bg-gray-600 mb-1"></div>
            <div class="w-6 h-1 bg-gray-600"></div>
          </label>
          <ul class=" 
          fixed h-screen border-l-4 border-octo-secondary right-0
           -mr-8 top-0 bg-slate-100 w-64 flex flex-col
           gap-4 pt-32 text-sm text-octo-secondary uppercase animate__animated animate__slideInRight" 
           v-show="isShow">
           <span class="absolute top-0 right-0 mr-10 mt-4" @click="isShow = !isShow">
             <i class='bx bx-x p-1 ring-1 ring-octo-secondary rounded-sm'></i>
           </span>
           <li class="cursor-pointer hover:bg-gray-200 w-full py-2">
              <a class="px-6" @click="redirectPage('')">Home</a>
            </li>
            <li class="cursor-pointer group relative hover:bg-gray-200 w-full py-2">
              <div class="">
                <a class="px-6" @click="redirectPage('Solutions')">Solutions</a>
                <i class='bx bxs-chevron-down' @click="submenu1 = !submenu1"></i>
              </div>
              <ul class="px-8 py-3 mt-4 text-sm rounded-md" v-show="submenu1">
                <li class=""><a @click="solutionRedirect('#bg-1')">Gateway</a></li>
                <li class="py-4">
                <div class="flex">
                  <a class="" @click="solutionRedirect('#bg-4')">Recharger</a>
                  <i class='bx bxs-chevron-down ml-10' @click="submenu = !submenu"></i>
                </div>
                  <ul class="py-2 px-6 text-sm bg-slate-50 mt-2 rounded-lg -right-1" v-show="submenu">
                    <li class="py-2"><a @click="redirectPage('Topup')">Top Up</a></li>
                    <li class="py-2"><a @click="redirectPage('Datapack')">Data pack</a></li>
                    <li class="py-2"><a @click="redirectPage('E-Giftcard')">E-GiftCard</a></li>
                  </ul>
                </li>
                <li><a class="py-4" @click="solutionRedirect('#bg-6')">Messenger</a></li>
              </ul>
            </li>
            
            <li class="cursor-pointer hover:bg-gray-200 w-full py-2">
              <a class="px-6" @click="redirectPage('news-and-promotion')">News & Promotion</a>
            </li>
            <li class="cursor-pointer group relative hover:bg-gray-200 w-full py-2">
              <a class="px-6" @click="redirectPage('AboutUs')">About Us</a>
              <i class='bx bxs-chevron-down ml-2' @click="submenu2 = !submenu2"></i>
              <div class="py-2 px-6 text-sm rounded-lg" v-show="submenu2">
                  <ul class="py-4 px-6">
                    <li class="py-2"><a @click="aboutUsRedirect('#ourstory')">Our Story</a></li>
                    <li class="py-2"><a @click="aboutUsRedirect('#vision-mission')">Vision And Mission</a></li>
                    <li class="py-2"><a @click="aboutUsRedirect('#whatwedo')">What we do</a></li>
                  </ul>
              </div>
            </li>
            <li class="cursor-pointer hover:bg-gray-200 w-full py-2">
              <a class="px-6" @click="redirectPage('help-faq')">Help & FAQ</a>
            </li>
            <div class="ring-1 ring-slate-300 mt-10"></div>
            <div class="px-6 mt-10">
              <span class="text-xs font-bold text-octo-primary">Follow us</span>
            </div>
            <div class="flex gap-4 justify-start px-6">
                  <i class='bx bxl-facebook ring-1 rounded-sm ring-octo-secondary px-2 py-2 text-lg'></i>
                  <i class='bx bxl-linkedin ring-1 rounded-sm ring-octo-secondary px-2 py-2 text-lg'></i>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</header>
<!--  -->
</template>

<script>

export default {
  data() {
    return {
      isOpen: false,
      submenu: false,
      submenu1: false,
      submenu2: false,
      Mobilemenu: false,
      isShow: false,
    }
  },
  mounted() {
    document.addEventListener('click', this.clickOutsideNavbar)
  },
  methods: {

    clickOutsideNavbar(event) {
      if (!this.$refs.navbar.contains(event.target)) {
        this.isShow = false
      }
    },
    
    async redirectPage(param) {
        //this.$router.go(0);
       await this.$router.push('/'+ param); //  this.$router.go( '/'+ param);
    },
    async aboutUsRedirect(param)
    {
        await this.$router.push({name: 'About Us', hash: param});
    },
    async solutionRedirect(param)
    {
      await this.$router.push({name: 'Solutions', hash: param});
    }
    // mouseover: function () {
    //         this.isOpen = true;
    //     },
    // mouseleave: function () {
    //     this.isOpen = false;
    // }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.clickOutsideNavbar)
  },
}
</script>

